import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from './app/routes';
import ScrollToTop from './components/ScrollToTop'
import './custom.css'

const isProd = import.meta.env.VITE_ENV === 'production'

// Akamai PCI SCRIPT
if(isProd) {
  const pciScript = document.createElement('script');
  pciScript.src = 'https://p11.techlab-cdn.com/665db9a3f620fa59e132b7fb.js'
  pciScript.crossOrigin = 'anonymous'
  document.getElementsByTagName('head')[0].appendChild(pciScript);
}

const container = document.getElementById('root');
const rootElement = ReactDOM.createRoot(container!)

rootElement.render(
  <BrowserRouter>
    <Provider store={store}>
      <ScrollToTop />
      <App />
    </Provider>
  </BrowserRouter>)